import { render, staticRenderFns } from "./PriceCurrent.vue?vue&type=template&id=609d6160&scoped=true"
import script from "./PriceCurrent.vue?vue&type=script&lang=js"
export * from "./PriceCurrent.vue?vue&type=script&lang=js"
import style0 from "./PriceCurrent.vue?vue&type=style&index=0&id=609d6160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d6160",
  null
  
)

export default component.exports